export const ORDER_DOCUMENTS_SECTION = 'documents-section';
